import React, {Component} from 'react'
import {Alert, Select, Spin} from "antd"
import PropTypes from "prop-types"
import {listSku} from "../../../../services/api/3dApi"

const {Option} = Select

class FilterProductType extends Component {
    state = {
        types: this.props.productTypes,
        options: [],
        loading: false,
        error: ''
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({
                types: this.props.productTypes
            })
        }
    }

    componentDidMount() {
        this._fetchOrderTypes()
    }

    _handleChange = (value) => {
        const {onChangeProductType} = this.props

        if (typeof onChangeProductType === 'function') {
            onChangeProductType(value)
        }
    }

    _fetchOrderTypes = async () => {
        this.setState({
            loading: true,
            error: ''
        })
        try {
            const {data: response} = await listSku()

            const {data, success, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            const regex = /\s/

            const newData = data.length > 0 && data.filter((item) => {
                return !regex.test(item.sku) && item
            })

            this.setState({
                loading: false,
                options: newData
            })

        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    render() {
        const {types, options, loading, error} = this.state
        const listOption = !!options && options.length > 0 && options.reduce((unique, obj) => {
            if (!unique.some(item => item.id === obj.id && item.sku === obj.sku)) {
              unique.push(obj);
            }
            return unique;
        }, []);

        return (
            <div className="FilterProductType">
                {error ? <Alert message={error} type={'error'}/> :
                    <Spin spinning={loading}>
                        <Select
                            mode="multiple"
                            style={{width: '100%'}}
                            showArrow={true}
                            placeholder="Vui lòng chọn loại sản phẩm bạn muốn tìm kiếm"
                            defaultValue={types}
                            onChange={this._handleChange}
                            value={types}
                            allowClear
                        >
                            {!!listOption && listOption.length > 0 &&
                                listOption.map((option) => {
                                    return <Option key={option._id} value={option.sku}>{option.sku}</Option>
                                })
                            }
                        </Select>
                    </Spin>
                }
            </div>
        )
    }
}

FilterProductType.defaultProps = {
    loading: false
}

FilterProductType.propTypes = {
    loading: PropTypes.bool,
    productTypes: PropTypes.array,
    onChangeProductType: PropTypes.func.isRequired
}

export default FilterProductType
